import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css"; // استدعاء ملف التنسيق

function Login({ setIsLoggedIn }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === "admin@gmail.com" && password === "5^7#op9)@d") {
      localStorage.setItem("isLoggedIn", "true");
      setIsLoggedIn(true);
      navigate("/dashboard");
    } else {
      alert("❌ مرفوض: البريد الإلكتروني أو كلمة المرور غير صحيحة");
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h1>لوحة التحكم - تسجيل الدخول</h1>

        <form onSubmit={handleLogin}>
          <label>البريد الإلكتروني</label>
          <input
            type="email"
            placeholder=""
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>كلمة المرور</label>
          <input
            type="password"
            placeholder="••••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">دخول</button>
        </form>

        <p className="note">🔒 الدخول مسموح للمسؤول فقط</p>
      </div>
    </div>
  );
}

export default Login;
